// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"31d6cfe0","429":"22341ef2","487":"86d3823a","616":"737781ca","749":"5d23d8a4"}[chunkId] + ".chunk.css";
};